<template>
  <div class="form-group row">
    <label for="observations" class="col-lg-4 label-text">
      Observations
    </label>
    <div class="loading col-lg-5" v-if="observationsLoading">
      Loading...
    </div>
    <div class="col-lg-8">
      <div class="form-group row"
        v-for="(observation, index) in this.observations"
        :key="index">
        <div class="col-sm-8 label-text">
          <p>{{ `${getObservationName(observation.typeId)}?` }}</p>
        </div>
        <div class="col-sm-4">
          <select v-if="!observationAckTypesLoading"
            data-vv-as="Observed"
            class="form-control"
            name="inspectionServiceObserved"
            v-model="observation.ackTypeId"
            @change="setObservationAckType(observation)"
            v-bind:id="`ackType-${index + 1}`"
            :ref="`observationAckTypeId-${index}`"
          >
            <option v-for="option in observationAckTypeOptions"
                    :key="option.id"
                    :value="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="col-lg-12">
          <label for="observationNotes" class="col-lg-4 label-text remove-padding">
            <span v-if="observation.ackTypeId === 2"
              class="text-danger">*</span>Notes
          </label>
          <textarea type="textarea"
                    class="form-control"
                    name="observationNotes"
                    v-model="observation.notes"
                    v-validate="`required_if:observationAckTypeId-${index},2|max:250`"
                    @change="setObservationNotes(observation)"
                    v-bind:id="`note-${index + 1}`"
                    data-vv-as="Observation Notes"
                    :placeholder="placeholderText(getObservationName(observation.typeId))"
                    :rows=
                      "placeholderText(getObservationName(observation.typeId)).length > 70 ? 3 : 2"
                    maxlength="250" />
            <small v-if="!errors.first('observationNotes')" class="form-text text-muted">
              Max 250 characters
            </small>
            <div class="invalid-feedback">{{ errors.first('observationNotes') }}
            </div>
          <hr>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { LookupModules } from '@/store/moduleConfig';
import VeeValidate from 'vee-validate';

const dict = {
  custom: {
    observationNotes: {
      required_if: 'The Observation Notes field is required when Yes is selected.',
    },
  },
};

VeeValidate.Validator.localize('en', dict);

export default {
  name: 'ObservationsForm',
  // inject the parent validator
  inject: ['$validator'],
  mounted() {
    this.$store.dispatch(`${LookupModules.SERVICE_OBSERVATION_TYPES.namespace}/fetchOptions`,
      LookupModules.SERVICE_OBSERVATION_TYPES.url).then(() => {
      if (!this.isInspectionServiceEdit) {
        this.setObservations(this.getDefaultObservations());
      }
    });
    this.$store.dispatch(`${LookupModules.SERVICE_OBSERVATION_ACK_TYPES.namespace}/fetchOptions`,
      LookupModules.SERVICE_OBSERVATION_ACK_TYPES.url);
  },
  computed: {
    ...mapState('Service', {
      isInspectionServiceEdit: state => state.isInspectionServiceEdit,
    }),
    ...mapState(LookupModules.SERVICE_OBSERVATION_ACK_TYPES.namespace, {
      observationAckTypesLoading: state => state.loading,
    }),
    ...mapState(LookupModules.SERVICE_OBSERVATION_TYPES.namespace, {
      observationsLoading: state => state.loading,
    }),
    ...mapGetters(LookupModules.SERVICE_OBSERVATION_ACK_TYPES.namespace, {
      observationAckTypeOptions: 'getActiveOptions',
    }),
    ...mapGetters(LookupModules.SERVICE_OBSERVATION_TYPES.namespace, {
      observationTypes: 'getActiveOptions',
      getObservationName: 'getName',
    }),
    observations: {
      get() {
        return this.$store.state.Service.currentService.observations;
      },
      set(value) {
        this.$store.dispatch('Service/setCurrentObservations', { value });
      },
    },
  },
  methods: {
    placeholderText(attributeName) {
      return `Enter ${attributeName} Notes`;
    },
    setObservations(observations) {
      this.$store.dispatch('Service/setCurrentObservations', { observations });
    },
    getDefaultObservations() {
      return this.observationTypes.map(observationType => ({
        typeId: observationType.id,
        name: observationType.name,
        ackTypeId: 1,
        notes: '',
      }));
    },
    setObservationAckType(observation) {
      this.$store.dispatch('Service/setObservation', { observation });
    },
    setObservationNotes(observation) {
      this.$store.dispatch('Service/setObservation', { observation });
    },
  },
};
</script>
